// AI туслах ↔ хуудсууд: одоогийн хуудасны контекст (AI-д "энэ анги" гэдгийг ойлгуулна), хүлээгдэж буй санал (хүснэгтэд шараар),
// баталсны дараа хуудсуудыг шинэчлэх дохио. Глобал store — React context шаардлагагүй (самбар бүх layout-аас гадна байрлана).
import { useEffect, useState } from "react";

let context = null;
let pending = []; // [{ id, kind, courseId, groupId, column, date, items: [{ studentId, value }], outcomeId?, part?, field? }]

export const setAiContext = (c) => { context = c; };
export const getAiContext = () => context;

export function setAiPending(list) {
  pending = list;
  window.dispatchEvent(new CustomEvent("ai:pending"));
}

// Баталсан / буцаасан → өгөгдөл өөрчлөгдсөн
export const emitAiChanged = (detail) => window.dispatchEvent(new CustomEvent("ai:changed", { detail }));
export function useAiChanged(fn) {
  useEffect(() => {
    const h = (e) => fn(e.detail || {});
    window.addEventListener("ai:changed", h);
    return () => window.removeEventListener("ai:changed", h);
  }, [fn]);
}

// Тухайн анги × хичээлийн хүлээгдэж буй санал
export function useAiPending(courseId, groupId) {
  const [list, setList] = useState(pending);
  useEffect(() => {
    const h = () => setList(pending);
    window.addEventListener("ai:pending", h);
    return () => window.removeEventListener("ai:pending", h);
  }, []);
  return list.filter((a) => a.courseId === courseId && a.groupId === groupId);
}

// Чатаас сонгох загвар (Opus / Sonnet / Haiku) — сонголтыг хөтөчид санана
let modelsP = null;
const KEY = "aiModel";
const readKey = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
export function useAiModel(instance) {
  const [models, setModels] = useState(null);
  const [model, setModelState] = useState(readKey);
  useEffect(() => {
    modelsP = modelsP || instance({ method: "get", url: "/ai/models", noMessage: true }).then((r) => r.data).catch(() => { modelsP = null; return null; });
    modelsP.then((d) => {
      if (!d) return;
      setModels(d.list);
      setModelState((m) => (d.list.some((x) => x.id === m) ? m : d.default));
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const setModel = (m) => { setModelState(m); try { localStorage.setItem(KEY, m); } catch (e) { /* хувийн горим */ } };
  return { models, model, setModel };
}
